CCL.bevergeTable = {
  autoload: [
    ['tableSlider', $('.checktable').length > 0],
    ['onDrinkPackagesLoad', $('.c-beverages-cards').length > 0]
  ],

  onDrinkPackagesLoad() {
    if ($('#promotionURL').data('promotionurl') && $('#promotionURL').data('promotionurl') !== '') {
      this.drinkPackagePromotionPricingAjax();
    }
  },


  drinkPackagePromotionPricingAjax() {
    const token = $('#csrfSessionToken').data('csrf');
    const promoUrl = $('#promotionURL').data('promotionurl');
    let ajaxUrl = promoUrl;
    let ajaxType = 'POST';
    if (window.location.hostname === 'localhost' && window.location.port === '6565') {
      ajaxUrl = '/_ui/responsive/ccl/assets/templates/ajax-clp/promo-price.json';
      ajaxType = 'GET';
    }

    const products = [];
    let promotionalSailingData = '';
    if ($('#maskedSailingData').length && $('#maskedSailingData').data('sailingdata') !== '') {
      promotionalSailingData = JSON.parse(JSON.stringify($('#maskedSailingData').data('sailingdata')));
    }

    $('.c-beverages-cards .c-product-card .btn.btn-red.general-add-to-cart-btn').each((index, element) => {
      console.dir(element);
      products.push({
        productCode: element.dataset.productcode,
        productBaseCode: element.dataset.productcode,
        productType: 'FS',
        productSubType: element.dataset.productcode === 'BB_1' ? 'BUBBLES' : null
      });
    });

    $.ajax({
      type: ajaxType,
      url: ajaxUrl,
      contentType: 'application/json',
      data: JSON.stringify({ products, promotionalSailingData })
    }).then((res) => {
      if (res && res.promotionsData.length) {
        $.each(res.promotionsData, (key, val) => {
          // show promoPill for all the CLP products
          $('body').find(`.${val.productBaseCode} .pills-wrap`).append(
            `<div class="best-seller general-best-seller">
              <span class="info-icon" aria-hidden="true">
                  <img src="/_ui/responsive/ccl/assets/icons/star_white.svg" alt="Featured" width="11" height="12">
              </span>
              ${val.promotionResultsData[0].description}
            </div>`
          );

          // code to replace html
          this.drinkPackagesPromoPriceHtml(val);
        });
      }
    }).catch((error) => {
      console.log('error occured');
    });
  },

  /* eslint-disable */
  drinkPackagesPromoPriceHtml(productPromoData) {
    if (productPromoData.discountedPrice.length > 1) {
      // if both values are not same that means we have separate adult & child
      if (productPromoData.discountedPrice[0].value !== productPromoData.discountedPrice[1].value) {
        let adultHtml = '';
        let childHtml = '';
        const oldAdultPriceObj = productPromoData.originalPrice.filter(x => x.priceGroupType === 'A')[0];
        const oldChildPriceObj = productPromoData.originalPrice.filter(x => x.priceGroupType === 'C')[0];

        const newAdultPriceObj = productPromoData.discountedPrice.filter(x => x.priceGroupType === 'A')[0];
        const newChildPriceObj = productPromoData.discountedPrice.filter(x => x.priceGroupType === 'C')[0];

        adultHtml = `<div><p class="price-person general-price-person ccl-d-inline-flex"><span class="general-price-drinks"><span class="strikeoutprice greytext" aria-label="before the price was ${oldAdultPriceObj.formattedValue}" role="textbox"> <b>${oldAdultPriceObj.formattedValue}</b></span > / Adult Per Day</span ></p> <b aria-label="current price is ${newAdultPriceObj.formattedValue}" role="textbox">${newAdultPriceObj.formattedValue}</b></div>`;

        childHtml = `<div><p class="price-person general-price-person ccl-d-inline-flex"><span class="general-price-drinks"><span class="strikeoutprice greytext" aria-label="before the price was ${oldChildPriceObj.formattedValue}" role="textbox"> <b>${oldChildPriceObj.formattedValue}</b></span > / Child Per Day</span ></p> <b aria-label="current price is ${newChildPriceObj.formattedValue}" role="textbox">${newChildPriceObj.formattedValue}</b></div>`;

        $('body').find(`.${productPromoData.productBaseCode} .no-strike-adult`).replaceWith(adultHtml);
        $('body').find(`.${productPromoData.productBaseCode} .no-strike-child`).replaceWith(childHtml);
      } else {
        const priceHtml = `<div><p class="price-person general-price-person ccl-d-inline-flex"><span class="general-price-drinks"><span class="strikeoutprice greytext" aria-label="before the price was ${productPromoData.originalPrice[0].formattedValue}" role="textbox"><b>${productPromoData.originalPrice[0].formattedValue}</b></span> / Person</span></p></div><b aria-label="current price is ${productPromoData.discountedPrice[0].formattedValue}" role="textbox">${productPromoData.discountedPrice[0].formattedValue}</b>`;
        $('body').find(`.${productPromoData.productBaseCode} .no-strike-adult`).replaceWith(priceHtml);
      }
    } else {
      if (productPromoData.salesPerUnitDescription) {
        const priceHtml = `<div>
        <p class="price-person general-price-person ccl-d-inline-flex">
        <span class="general-price-drinks">
        <span class="strikeoutprice greytext" aria-label="before the price was ${productPromoData.originalPrice[0].formattedValue}" role="textbox"><b>${productPromoData.originalPrice[0].formattedValue}</b></span> / ${productPromoData.salesPerUnitDescription}</span></p></div><b aria-label="current price is ${productPromoData.discountedPrice[0].formattedValue}" role="textbox"> ${productPromoData.discountedPrice[0].formattedValue}</b>`;
        $('body').find(`.${productPromoData.productBaseCode} .no-strike-adult`).replaceWith(priceHtml);
      } else {
        const priceHtml = `<div><p class="price-person general-price-person ccl-d-inline-flex"><span class="general-price-drinks"><span class="strikeoutprice greytext" aria-label="before the price was ${productPromoData.originalPrice[0].formattedValue}" role="textbox"><b>${productPromoData.originalPrice[0].formattedValue}</b></span> / Person</span></p></div><b aria-label="current price is ${productPromoData.discountedPrice[0].formattedValue}" role="textbox">${productPromoData.discountedPrice[0].formattedValue}</b>`;
        $('body').find(`.${productPromoData.productBaseCode} .no-strike-adult`).replaceWith(priceHtml);
      }
    }
  },
  /* eslint-enable */

  tableSlider() {
    $('.up-button').click((event) => {
      let link = null;
      event.preventDefault();
      $('.checktable tr:gt(4) td').slideToggle('fast', 'linear');
      $('.up-button').toggleClass('up-button-reverse');
      if ($('.up-button').hasClass('up-button-reverse')) {
        link = $('.c-beverage-table').offset().top;
      } else {
        link = 2200; // $('.up-button').offset().top;
      }

      $('html, body').animate({
        scrollTop: link
      }, 200);

      const expand = $('.up-button').attr('aria-expanded');
      $('.up-button').addClass('ada-element-focus');
      setTimeout(() => {
        $(() => {
          if (expand === 'false') {
            $('.up-button').attr('aria-expanded', 'true');
            $('.up-button').attr('aria-label', 'View less information');
          } else {
            $('.up-button').attr('aria-expanded', 'false');
            $('.up-button').attr('aria-label', 'View more information');
          }
          $('.up-button').focus();
        });
      }, 300);
    });
  }
};




// WEBPACK FOOTER //
// ./src/app/components/c-beverage-table/beverage-table.js